import React from 'react';
import i18n from '../../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {Hidden, withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import FormNumber from "../../Form/FormNumber";
import InputAdornment from "@material-ui/core/InputAdornment";
import SignatureCanvas from 'react-signature-canvas';
import FormRadio from "../../Form/FormRadio";

class PowerOperatedRollingDoors extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData1: '',
            signatureData2: '',
            updatingFields: false,
        };
    }

    sigCanvas1 = {}
    sigCanvas2 = {}

    handleSign1 = () => {
        this.setState({signatureData1: this.sigCanvas1.toDataURL()});
    }
    handleSign2 = () => {
        this.setState({signatureData2: this.sigCanvas2.toDataURL()});
    }

    render() {
        const {
            classes,
            values,
            protocol,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
        } = this.props;

        values.signature1 = this.state.signatureData1
        values.signature2 = this.state.signatureData2
        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>
                <Grid item>
                    <Grid container spacing={8} alignItems="center">
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer"
                                label='Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        {/*<Grid item xs={2}>*/}
                        {/*    <Typography className={classes.textRight} component={"div"}*/}
                        {/*                variant={"body1"}>*/}
                        {/*        Geräteart/-typ*/}
                        {/*    </Typography>*/}
                        {/*</Grid>*/}
                        <Grid item xs={3}>
                            <FormField
                                type="number"
                                name="construction_year"
                                label='Baujahr:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.construction_year}
                                inputProps={{
                                    max : 2100,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="gate_size"
                                label='Torflügelgröße (mm):'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.gate_size}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="inventory_number"
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <Typography className={classes.textCenter} component={"div"}
                                        variant={"body1"}>
                                Mw Messung HSK (H:220, L+R 200mm und Mitte):
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="location"
                                label='Einbauort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.location}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={1}>
                            <FormField
                                type="number"
                                name="f_dyn"
                                label='F dyn:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.f_dyn}
                                inputProps={{
                                    maxLength : 5,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <FormField
                                type="number"
                                name="t_dyn"
                                label='t dyn:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.t_dyn}
                                inputProps={{
                                    maxLength : 5,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <FormField
                                type="number"
                                name="f_end"
                                label='F end:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.f_end}
                                inputProps={{
                                    maxLength : 5,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormField
                                type="text"
                                name="control_type"
                                label='Art der Steuerung (z.B. Taster, Zugschalter, Lichtschranke, Radar, Infrarot, Kontaktschwelle):'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.control_type}
                                inputProps={{
                                    maxLength : 30,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>
                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        1. Antrieb
                    </Typography>
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a) Antriebs- und Konsolenbefestigung
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_1_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        required={true}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_1_content_1 || ''}
                        touched={touched.check_1_content_1}
                        error={errors.check_1_content_1}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        b) Geräusche und Dichtheit des Antriebes
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_1_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_1_content_2 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        c) Nothandbetätigung und elektr. Verriegelung
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_1_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_1_content_3 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        d) Bremswirkung, Nachlauf
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_1_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_1_content_4 || ''}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        2. Schaltautomat und Steuergeräte
                    </Typography>
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a) Betriebsendschaltereinstellung und Funktion
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_2_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_2_content_1 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        b) Sicherheitsendschaltereinstellung und Funktion
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_2_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_2_content_2 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        c) Zusatzendschaltereinstellung und Funktion
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_2_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_2_content_3 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        d) Einstellung des Motorschutzschalters
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_2_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_2_content_4 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        e) elektr. u. mech. Funktion der Befehlsgeber
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_2_content_5"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_2_content_5 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        f) elektr. Verriegelung Schlupftür o. Geh-/Drehflügel
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_2_content_6"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_2_content_6 || ''}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        3. Kettenradvorgelege (soweit vorhanden)
                    </Typography>
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a) Kette: Fluchten und Verschleiß
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_3_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_3_content_1 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        b) Kette: Spannung, ggf. nachspannen
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_3_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_3_content_2 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        c) Kette: Sauberkeit, Schmierung
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_3_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_3_content_3 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        d) Kettenräder: Verschleiß, fester Sitz
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_3_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_3_content_4 || ''}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        4. Sicherung gegen unbeabsichtigtes Schließen des Torflügels
                    </Typography>
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        A) Separate Fangvorrichtung auf die Welle wirkend
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_4_content_a"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_4_content_a || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a)
                    </Typography>
                </Grid>
                <Grid item md={8} xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Befestigung und Zustand
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_4_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_4_content_1 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        b)
                    </Typography>
                </Grid>
                <Grid item md={8} xs={5}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        Bewegl. Teile: Verschleiß, Korrosion, Gängigkeit
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_4_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_4_content_2 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        c)
                    </Typography>
                </Grid>
                <Grid item md={8} xs={5}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        Schild: Vollständigkeit, Lesbarkeit
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_4_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_4_content_3 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        d)
                    </Typography>
                </Grid>
                <Grid item md={8} xs={5}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        elektr. Abschaltung d. Antriebes (ab 01.04.1992)
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_4_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_4_content_4 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        B) Antrieb mit integrierter Fangvorrichtung
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_4_content_b"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_4_content_b || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        C) Federwelle
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_4_content_c"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_4_content_c || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a)
                    </Typography>
                </Grid>
                <Grid item md={8} xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Federschmierung (soweit notwendig)
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_4_content_5"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_4_content_5 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        b)
                    </Typography>
                </Grid>
                <Grid item md={8} xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Unversehrtheit der Federn
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_4_content_6"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_4_content_6 || ''}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        5. Welle, Andruckwelle und Lagerung
                    </Typography>
                </Grid>

                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a) Schweißnähte der Achszapfen und Konsolen
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_5_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_5_content_1 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        b) Achszapfen, Lager, Stellringe
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_5_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_5_content_2 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        c) Nothandbetätigung und elektr. Verriegelung
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_5_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_5_content_3 || ''}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        6. Torflügel
                    </Typography>
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a) Verschleiß, Deformation
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_6_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_6_content_1 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        b) Seitenarretierung (z.B.: Endstücke)
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_6_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_6_content_2 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        c) Aufhängung, Befestigungsschrauben
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_6_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_6_content_3 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        d) Sturmhaken, Sturmrollen
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_6_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_6_content_4 || ''}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        7. Sicherung der Hauptschließkante
                    </Typography>
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a) Zustand und Funktion
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_7_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_7_content_1 || ''}
                    />
                </Grid>
                <Grid item md={6} xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        b) Lichtschranke(n) (Höhe angeben)
                    </Typography>
                </Grid>
                <Grid xs={2}>
                    <FormNumber
                        type="text"
                        name="check_7_content_2_height"
                        onChange={handleChange}
                        value={this.state.value}
                        fixedDecimalScale={false}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">mm</InputAdornment>
                        }}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>
                        &nbsp;
                    </Grid>
                </Hidden>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_7_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_7_content_2 || ''}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        8. Einzugsicherung
                    </Typography>
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a) Zustand und Funktion
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_8_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_8_content_1 || ''}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        9. Führungsschienen
                    </Typography>
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a) Befestigung und Zustand (Deformation)
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_9_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_9_content_1 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        b) Verschleiß und Schmierung
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_9_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_9_content_2 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        c) Einlauftrichter
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_9_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_9_content_3 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        d) Enddämpfer
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_9_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_9_content_4 || ''}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        10. Sicherung Quetsch- und Scherstellen (soweit notwendig)
                    </Typography>
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a) Zustand und Funktion
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_10_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_10_content_1 || ''}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        11. Kennzeichnungsschild
                    </Typography>
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a) Vollständigkeit und Lesbarkeit
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_11_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_11_content_1 || ''}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"h6"}>
                        12. Abschchließbarer Hauptschalter/CCE-Stecker
                    </Typography>
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        a) Vorhanden
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_12_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_12_content_1 || ''}
                    />
                </Grid>
                <Grid item md={9} xs={6}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        b) Zustand und Funktion
                    </Typography>
                </Grid>
                <Grid item md={3} xs={6}>
                    <FormRadio
                        name="check_12_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'deficiency',
                                label : 'B.'
                            },
                            {
                                value : 'free',
                                label : 'frei'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_12_content_2 || ''}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <FormField
                        type="text"
                        name="reason"
                        label='Befund / Mängel / Bemerkungen'
                        multiline
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.reason}
                    />
                </Grid>
                {/*<Grid item xs={6}>*/}
                {/*    <FormField*/}
                {/*        type="text"*/}
                {/*        name="notations"*/}
                {/*        label='Befund / Mängel / Bemerkungen'*/}
                {/*        multiline*/}
                {/*        onChange={handleChange}*/}
                {/*        onBlur={handleBlur}*/}
                {/*        value={values.notations}*/}
                {/*    />*/}
                {/*</Grid>*/}

                <Grid item xs={12}>
                    <FormRadio
                        name="inspection_tag"
                        options={[
                            {
                                value : 'yes',
                                label : 'Prüfplakette erteilt',
                            },
                            {
                                value : 'no',
                                label : 'Prüfplakette nicht erteilt',
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadio}
                        classNameRadio={classes.formButton}
                        onBlur={handleBlur}
                        value={values.inspection_tag}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Datum:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="current_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.current_date}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Nächster Prüftermin:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="next_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.next_date}
                    />
                </Grid>

                <Hidden smDown>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas1 = ref }}
                                    onEnd={this.handleSign1}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas2 = ref }}
                                    onEnd={this.handleSign2}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Auftraggeber
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Prüfer
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Hidden mdUp>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas1 = ref }}
                            onEnd={this.handleSign1}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Auftraggeber
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>&nbsp;</Grid>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas2 = ref }}
                            onEnd={this.handleSign2}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Prüfer
                        </Typography>
                    </Grid>
                </Hidden>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    textLeft: {
        textAlign: "left",
    },
    textCenter: {
        textAlign: "center",
    },
    textRight: {
        textAlign: "right",
    },
    rightSide: {
        marginTop: '-50px',
    },
    formRadio: {
        flexDirection: "row",
        marginLeft: '100px'
    },
    formButton: {
    },
    formSelection: {
        flexDirection: "row",
    },
});

export default withStyles(styles)(PowerOperatedRollingDoors)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/PowerOperatedRollingDoors.js